import React from 'react';
import { Link } from 'react-router-dom';
import '../resources/Sidenav.css';

const Sidenav = () => (
  <nav className="sidenav">
    <ul>
      <li><Link to="/">Profile</Link></li>
      <li><Link to="/posts">Posts</Link></li>
      <li><Link to="/contact">Contact Me</Link></li>
    </ul>
  </nav>
);

export default Sidenav;
